import React from 'react'
import { Button } from '@mui/material'
import arrow_btn from '../images/arrow_btn.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HomeGetCompliant = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate()

    return (

        <div className={`container mx-auto px-2 xl:max-w-[1000px] 3xl:max-w-[1200px] ${props.className}`} >
            <div className="mx-5">
                <div
                    className={`bg-blueBG bg-[length:100%_100%] bg-center rounded-[24px] sm:rounded-[0px] bg-no-repeat relative w-[100%] min-h-[300px] sm:min-h-[340px] flex justify-center`}
                >
                    <div className='flex flex-col justify-center h-[100%] absolute p-5 sm:w-[100%] md:w-[75%] z-[1] text-center' >
                        <h1 className='NunitoSans text-[20px] sm:text-[35px] 3xl:text-[40px] font-[800] text-[#fff] talkAnExpertTitle capitalize'>
                            {t("choose_vitta")}
                        </h1>
                        <span className='NunitoSans font-[400] text-[14px] sm:text-[16px] text-[#fff] max-w-[95%] mx-auto'>{props.content}</span>
                        <div className='pt-3 lg:pt-8 flex justify-center'>
                            <div className="requestDemoBtnOuter" onClick={() => navigate("/contact-us")}>
                                <Button className="sora requestDemoBtn" >{t("request_demo")}<img draggable="false" src={arrow_btn} className="w-[9px] sm:w-[12px] ml-[4px]" alt="Arrow_up_small" /></Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeGetCompliant